export default __webpack_public_path__ + "static/media/game-type-03.4ef34255.png";